export default __webpack_public_path__ + "static/media/vuesax-linear-user.afae758e.svg";